import React from 'react'

interface Props{
    styleCssImage: string,
   
}
const LogoTransfer: React.FC<Props> = ({
  styleCssImage

}) => {
  return (
    <svg
  
    className={`${styleCssImage} fill-[#5754E5]`}
     width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10"  className='w-[60px]' />
      <path
        d="M30.5013 45.0833V39.25M24.668 42.1667V39.25M36.3346 42.1667V39.25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M41.7279 37.7916C42.9703 37.5575 43.9076 37.1666 44.6609 36.5143C46.5404 34.8869 46.5404 32.2677 46.5404 27.0292C46.5404 21.7907 46.5404 19.1714 44.6609 17.544C42.7816 15.9166 39.7567 15.9166 33.707 15.9166H27.2904C21.2407 15.9166 18.2158 15.9166 16.3364 17.544C14.457 19.1714 14.457 21.7907 14.457 27.0292C14.457 32.2677 14.457 34.8869 16.3364 36.5143C17.0898 37.1666 18.0271 37.5575 19.2695 37.7916"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M39.979 27.5834H39.9648"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0376 27.5834H21.0234"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.875 31.2179C34.1773 32.5354 32.908 33.4167 31.4578 33.4167C29.256 33.4167 27.4712 31.3854 27.4712 28.8796V26.287C27.4712 23.7813 29.256 21.75 31.4578 21.75C32.908 21.75 34.1773 22.6312 34.875 23.9488M26.125 27.5833H31.8462"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LogoTransfer
